import { isGroupNavItem, isPageNavItem } from "./index";
import type { SingleLineMenu } from "../types";

export function getMenuActiveItemIndex(
  pathname: string,
  menuItems: SingleLineMenu,
) {
  return menuItems.findIndex(
    (item) =>
      isGroupNavItem(item) &&
      hasPathMatchRecursive(pathname, item.subMenuItems),
  );
}

export function hasPathMatchRecursive(
  pathname: string,
  menuItems: SingleLineMenu,
): boolean {
  return menuItems.some((item) => {
    if (isPageNavItem(item) && pathname.endsWith(item.url)) {
      return true;
    }

    return (
      isGroupNavItem(item) && hasPathMatchRecursive(pathname, item.subMenuItems)
    );
  });
}
